<template>
  <div :class="$style.root">
    <AtomsConsumerImage
      src="/images/components/campaign/spring_campaign_banner_pc.png"
      alt="春のキャンペーンバナー"
      :width="1280"
      class="page-parts-pc"
    />
    <AtomsConsumerImage
      src="/images/components/campaign/spring_campaign_banner_sp.png"
      alt="春のキャンペーンバナー"
      :width="768"
      class="page-parts-sp"
    />
  </div>
</template>

<script setup lang="ts"></script>

<style module lang="scss">
.root {
  @include container-lg;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 1rem;
  cursor: pointer;
  padding-bottom: 2rem !important;
  img {
    width: 100%;
    border-radius: 0.375rem;
  }
}
</style>
